const ValidationHelper = {
  /**
   * Validates a Brazilian CPF (Individual Taxpayer ID)
   */
  isValidCPF: (cpf) => {
    const cleanCPF = cpf.replace(/\D/g, '');
    if (cleanCPF.length !== 11 || /^(\d)\1{10}$/.test(cleanCPF)) return false;

    const digits = cleanCPF.split('').map(Number);
    const calculateCheckDigit = (factor) => {
      let sum = 0;
      for (let i = 0; i < factor - 1; i++) {
        sum += digits[i] * (factor - i);
      }
      const remainder = (sum * 10) % 11;
      return remainder >= 10 ? 0 : remainder;
    };

    return calculateCheckDigit(10) === digits[9] && calculateCheckDigit(11) === digits[10];
  },

  /**
   * Validates a Brazilian CNPJ (Corporate Taxpayer ID)
   * Note: Compatible with numeric and the new alphanumeric format starting 2026.
   */
  isValidCNPJ: (cnpj) => {
    const cleanCNPJ = cnpj.replace(/\D/g, '');

    if (cleanCNPJ.length !== 14 || /^(\d)\1{13}$/.test(cleanCNPJ)) return false;

    const digits = cleanCNPJ.split('').map(Number);

    const calculateCheckDigit = (slice) => {
      let factor = slice.length - 7;
      let sum = 0;

      for (let i = slice.length; i >= 1; i--) {
        const n = slice[slice.length - i];
        sum += n * factor--;
        if (factor < 2) factor = 9;
      }

      const remainder = sum % 11;
      return remainder < 2 ? 0 : 11 - remainder;
    };

    const firstDigit = calculateCheckDigit(digits.slice(0, 12));
    const secondDigit = calculateCheckDigit(digits.slice(0, 13));

    return firstDigit === digits[12] && secondDigit === digits[13];
  },

  isValidPassport: (value) => {
    return /^[A-Za-z0-9]{5,20}$/.test(value);
  },

  isValidBrazilianPhone : (phone) => {
    if (!phone) return false;

    const digits = phone.replace(/\D/g, '');

    // DDD (2) + fixo (8) ou celular (9)
    if (digits.length === 10) {
      return /^[1-9]{2}[2-5]\d{7}$/.test(digits);
    }

    if (digits.length === 11) {
      return /^[1-9]{2}9\d{8}$/.test(digits);
    }

    return false;
  },

  isValidEmail: (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

};

export default ValidationHelper;